import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ReplacePageComponent} from './replace-page/replace-page.component';
import {RepairPageComponent} from './repair-page/repair-page.component';
import {UnknownPageComponent} from './unknown-page/unknown-page.component';
import {WizardComponent} from './wizard/wizard.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {UploadPageComponent} from './upload-page/upload-page.component';
import {WIZARD_ROUTES} from './wizard-routes';
import {NoActionPageComponent} from './no-action-page/no-action-page.component';

const routes: Routes = [
  {
    path: '',
    component: WizardComponent,
    children: [
      {
        path: WIZARD_ROUTES.UPLOAD_PAGE,
        component: UploadPageComponent
      }, {
        path: WIZARD_ROUTES.REPLACE_PAGE,
        component: ReplacePageComponent
      }, {
        path: WIZARD_ROUTES.REPAIR_PAGE,
        component: RepairPageComponent
      }, {
        path: WIZARD_ROUTES.NO_ACTION_PAGE,
        component: NoActionPageComponent
      }, {
        path: WIZARD_ROUTES.UNKNOWN_PAGE,
        component: UnknownPageComponent
      }, {
        path: WIZARD_ROUTES.ERROR_PAGE,
        component: ErrorPageComponent
      },
      {
        path: '**',
        redirectTo: WIZARD_ROUTES.START_PAGE
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WizardRoutingModule {
}
